import { WebPageJsonLd } from "next-seo";
import { addBaseUrl } from "./addBaseUrl";
import { Routes } from "~/routes";

// // // //

export function getAssetScreenerPageDescription(): string {
    return `Compare tokenized assets by yield, term, liquidity, and risk.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Invest List page using the `WebPageJsonLd` component from `next-seo`.
 *
 * @param {Object} props - The component props.
 * @param {Article} props.network - The Network data used to generate SEO metadata.
 */
export function AssetScreenerSEO() {
    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(Routes.assetScreener)}
            description={getAssetScreenerPageDescription()}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
